import React, { ReactComponentElement } from 'react';
import './StandardEquipment.scss';
import { Breakpoints, Infobox, Layout, Text, TextAlignment, TextTag, TokenTextAppearance } from '@volkswagen-onehub/components-core';
import { useTranslation } from 'react-i18next';
import { LayerHandleV2 } from '@volkswagen-onehub/layer-manager';

export default function StandardEquipment(props: Props) {
	const { accessoryListStandard, onClickDisclaimer, footnotes } = props;
	const { t } = useTranslation('ns1', { useSuspense: false });

	const breakpoints = {
		[Breakpoints.b1600]: [
			{ name: '.', columns: 2 },
			{ name: 'a', columns: 6 },
			{ name: '.', columns: 1 },
			{ name: 'b', columns: 6 },
			{ name: '.', columns: 1 },
			{ name: 'c', columns: 6 },
			{ name: '.', columns: 2 },
		],
		[Breakpoints.b960]: [
			{ name: '.', columns: 2 },
			{ name: 'a', columns: 9 },
			{ name: '.', columns: 2 },
			{ name: 'b', columns: 9 },
			{ name: '.', columns: 2 },
		],
		[Breakpoints.default]: [
			{ name: '.', columns: 2 },
			{ name: 'a', columns: 20 },
			{ name: '.', columns: 2 },
			{ name: '.', columns: 2 },
			{ name: 'b', columns: 20 },
			{ name: '.', columns: 2 },
			{ name: '.', columns: 2 },
			{ name: 'c', columns: 20 },
			{ name: '.', columns: 2 },
		],
	};

	let body: ReactComponentElement<any>;
	if (!accessoryListStandard || accessoryListStandard.length === 0) {
		body = (
			<div className="no-items-error">
				<Infobox hideIcon>
					<Text appearance={TokenTextAppearance.label100} textAlign={TextAlignment.center}>
						{t('standardEquipment.notFound')}
					</Text>
				</Infobox>
			</div>
		);
	} else {
		body = (
			<Layout appearance={breakpoints}>
				{accessoryListStandard.map((text) => (
					<Text className="equipment-item" appearance={TokenTextAppearance.copy200} key={`standard-feature-${text}`}>
						{text}
					</Text>
				))}
			</Layout>
		);
	}

	return (
		<>
			<div className="equipment-header">
				<Text tag={TextTag.h2} appearance={TokenTextAppearance.headline400}>
					{t('standardEquipment.title')}{' '}
					<button
						type="button"
						className="disclaimer-button"
						onClick={() => {
							onClickDisclaimer(2);
						}}
					>
						{footnotes[2].reference}
					</button>
				</Text>
			</div>
			{body}
		</>
	);
}

interface Props {
	accessoryListStandard: string[];
	onClickDisclaimer: (disclaimerNumber: number) => void;
	footnotes: { reference: string; text: string; handle: LayerHandleV2<any> }[];
}
